export default {
    'Bid is accepted':' Congratulations, your bid ',
    'Bid is declined':' declined your bid ',
    'Interview is accepted':` Interview Scheduled: You have a scheduled Interview with `,
    'Offer is accepted':' Your offer got accepted from ',
    'Bid is placed':' Important: ',
    'Profile is submitted':' Your profile got submitted by ',
    'Interview is proposed':' You have new propsed interview from ',
    'Interview is scheduled': ' Your interview is scheduled by ',
    'Offer is made':' You have new offer from ',
    'Candidate is hired':' You got hired from ',
    'Candidate is moved to on billing':' You have been moved to onBilling by ',
    'Candidate is cancelled':' You have been moved to canceled by ',
    'Candidate is terminated':' You have been moved to terminated by ',
    'Job is completed':' Your gig is completed and moved to offBilling ',
    'Interview is canceled':' declined your interview request ',
    'Moved to Rating':' has completed the gig ',
    'Rating is created':' You have received a rating from ',
    'Interview is rescheduled': ' has proposed new interview times ',
    'Candidate is rejected': ' Your offer has been declined by ',
    'First Gig Created': ' Congrats! You have created your first gig ',
    'JR Gig Created' : ' A new gig ',
    'JR Gig Closed' : ' This gig ',
    'bid placed notify employer' : ' Your Bid was sent to ',
    'Profile Updated' : ' Your Profile was updated ',
    'Your bid has been retracted' : ' Alert:  '
  };